import type { ComponentProps } from "react";

import type { Calendar } from "./component";

import { isPastDate } from "~/shared/date";
import type { Fn } from "~/shared/fp";

const disablePastDates: Extract<
  NonNullable<ComponentProps<typeof Calendar>["disabled"]>,
  Fn
> = isPastDate;

export { disablePastDates };
